module.exports = __webpack_public_path__ + "static/media/selvSuccessBordered.e40eaeb8.svg";